import { GET_PARENT_PROJECTS, GET_PARENT_PROJECTS_SUCCESS, GET_PARENT_PROJECTS_ERROR, GET_PARENT_PROJECTS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetParentProjects = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARENT_PROJECTS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PARENT_PROJECTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PARENT_PROJECTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PARENT_PROJECTS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetParentProjects;
